export const CREATE_PLATFORM = 'CREATE_PLATFORM'
export const GET_PLATFORM_INFO = 'GET_PLATFORM_INFO'
export const SAVE_PLATFORM_INFO = 'SAVE_PLATFORM_INFO'

export const GET_AUTHORITY_UTL = 'GET_AUTHORITY_UTL'

export const GET_WX_TEMPLATE_LIST = 'GET_WX_TEMPLATE_LIST'
export const USE_TEMPLATE = 'USE_TEMPLATE'

export const GET_DOMAINS = 'GET_DOMAINS'
export const RESET_DOMAINS = 'RESET_DOMAINS'
export const GET_DOMAIN_COUNTS = 'GET_DOMAIN_COUNTS'

export const GET_CONFIG = 'GET_CONFIG'
export const SET_CONFIG = 'SET_CONFIG'

export const GET_PAGES = 'GET_PAGES'
export const GET_CATEGORY = 'GET_CATEGORY'
export const SUBMIT_AUDIT = 'SUBMIT_AUDIT'

export const GET_MINIPROGRAMLIST = 'GET_MINIPROGRAMLIST'
export const GET_TICKET = 'GET_TICKET'
